import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_dashboard_data: { message: "idle" },
};

export const retrieve_tenant_dashboard_data_Slice = createSlice({
 name: "retrieve_tenant_dashboard_data",
 initialState,
 reducers: {
  success_retrieve_tenant_dashboard_data: (state, action) => {
   state.retrieve_tenant_dashboard_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_dashboard_data: (state, action) => {
   state.retrieve_tenant_dashboard_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_dashboard_data: (state) => {
   state.retrieve_tenant_dashboard_data = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_dashboard_data: (state) => {
   state.retrieve_tenant_dashboard_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_dashboard_data, fail_retrieve_tenant_dashboard_data, reset_retrieve_tenant_dashboard_data, loading_retrieve_tenant_dashboard_data } = retrieve_tenant_dashboard_data_Slice.actions;

export default retrieve_tenant_dashboard_data_Slice.reducer;